var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-bar",class:_vm.className},_vm._l((_vm.titles),function(item,index){return _c('div',{key:index},[_c('div',{class:{ active: _vm.currentIndex === index },on:{"click":function($event){return _vm.titleClick(index)}}},[_vm._v("\n      "+_vm._s(item)+"\n    ")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fe30b1d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabBar/index.vue
// module id = null
// module chunks = 